"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createSongwriterFormFields = exports.createSongwriterFormSchema = void 0;
const zod_1 = require("zod");
const error_messages_1 = require("@Const/error-messages");
const error_messages_2 = require("@Entities/schemas/work/error-messages");
const validate_1 = require("@App/helpers/validate");
const form_field_types_1 = require("@App/enum/form-field-types");
const react_1 = __importDefault(require("react"));
const populate_schema_1 = __importDefault(require("@App/forms/v2/helpers/populate-schema"));
const SongwriterNameTooltip_1 = __importDefault(require("@Scenes/SongwriterRegistrationScene/Tooltips/SongwriterNameTooltip"));
const IpiTooltip_1 = __importDefault(require("@Scenes/SongwriterRegistrationScene/Tooltips/IpiTooltip"));
const createSongwriterFormSchema = zod_1.z.object({
    name: zod_1.z.string().min(1, error_messages_1.REQUIRED_MESSAGE).max(200, (0, error_messages_2.stringSizeMaxMessage)('Name', 200)),
    ipiNumber: zod_1.z
        .string()
        .max(11, (0, error_messages_2.stringSizeMaxMessage)('IPI Number', 11))
        .refine((ipi) => (0, validate_1.IPIValidator)(ipi, false), 'Invalid IPI Number')
        .optional(),
});
exports.createSongwriterFormSchema = createSongwriterFormSchema;
const createSongwriterFormFieldsNoSchema = {
    name: {
        name: 'name',
        label: 'Songwriter name',
        type: form_field_types_1.FormFieldTypes.TEXT,
        inputHeader: (react_1.default.createElement("h5", null,
            "Songwriter Name",
            react_1.default.createElement(SongwriterNameTooltip_1.default, null))),
    },
    ipiNumber: {
        name: 'ipiNumber',
        label: 'Writer IPI',
        type: form_field_types_1.FormFieldTypes.TEXT,
        tooltip: react_1.default.createElement(IpiTooltip_1.default, null),
    },
};
const createSongwriterFormFields = (0, populate_schema_1.default)(createSongwriterFormFieldsNoSchema, createSongwriterFormSchema);
exports.createSongwriterFormFields = createSongwriterFormFields;
